import * as R from 'ramda';
import moment from 'moment';

export default function SRGenerateReportDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  reportsDataService
) {
  const vm = this;

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleSubmit = handleSubmit;
  vm.handleParameterChange = handleParameterChange;

  _activate();

  function _activate() {
    initializeDefaultParameters();
  }

  function initializeDefaultParameters() {
    if (vm.report.reportParameters !== null && vm.report.reportParameters !== undefined) {
      vm.report.reportParameters.forEach(parameter => {        
        // Numeric
        if (parameter.parameterDataType === 'numeric') {
          const value = vm.report[`parameter${parameter.parameterId}Value`];
          if (value === null || value === undefined) {
            vm.report[`parameter${parameter.parameterId}Value`] = Number(parameter.defaultValue);
          }
        }
      });
    }
  }

  /** ********************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleSubmit($event) {
    loaderService.showViewLoader = true;
    $event.stopPropagation();
    const parameters = _getReportParametersFromUI(vm.report);

    _runReport(vm.serviceId, vm.reportGroupId, vm.report.renderFormat, parameters).then(() => {
      loaderService.showViewLoader = false;
    });
  }

  function handleParameterChange(parameter) {
    const value = _getUserValue(parameter);

    if ((vm.report.reportParameters !== null) && (vm.report.reportParameters !== undefined)) {
      const paramsToUpdate = R.find(R.propEq('dependantUponId', parameter.parameterId), vm.report.reportParameters);

      if ((paramsToUpdate !== null) && (paramsToUpdate !== undefined)) {
        loaderService.showViewLoader = true;
        reportsDataService.getDependantValues(parameter.reportGroupId, paramsToUpdate.parameterId, value)
          .then((response) => {
            const retParam = response.data;
            vm.report.reportParameters.forEach((param) => {
              if (param.parameterId === retParam.parameterId) {
                param.reportParameterValues = retParam.reportParameterValues;
                param.userValue = '';
                const selectedValuesObj = vm.report;
                if ((selectedValuesObj !== null) && (selectedValuesObj !== undefined)) {
                  const paramSelectedValuesObj = vm.report[`parameter${param.parameterId}Value`];
                  if ((paramSelectedValuesObj !== null) && (paramSelectedValuesObj !== undefined)) {
                    vm.report[`parameter${param.parameterId}Value`] = '';
                  }
                }
              }
            });
            loaderService.showViewLoader = false;
          });
      }
    }
  }

  /** ********************************************
   * Private Functions
   */

  function _getReportParametersFromUI(report) {
    const reportParameters = report.reportParameters;
    if (R.isEmpty(reportParameters) || R.isNil(reportParameters)) {
      return null;
    }
    return R.map(
      parameter => ({
        parameterName: parameter.parameterName,
        parameterValue: _getUserValue(parameter)
      }),
      reportParameters
    );
  }

  function _getUserValue(parameter) {
    
    // DateTime
    if (parameter.parameterDataType === 'datetime') {
      if (parameter.isRequired === true) {
        return moment(parameter.userValue).format('MM/DD/YYYY');
      }

      if (parameter.isRequired === false) {
        return null;
      }
    }

    // Multiselect
    if (parameter.parameterDataType === 'multiselect') {
      const values = vm.report[`parameter${parameter.parameterId}Value`];
      if (values.includes('All') === true) {
        return 'All';
      }
      return values.join();
    }

    // Numeric
    if (parameter.parameterDataType === 'numeric') {
      let retVal = null;
      const value = vm.report[`parameter${parameter.parameterId}Value`];
      if (value !== undefined) {
        retVal = value;
      }
      return retVal;
    }

    return vm.report[`parameter${parameter.parameterId}Value`];
  }

  function _runReport(serviceId, reportGroupId, renderFormat, parameters) {
    alerts.success('Generating report...');
    if (vm.doArchive) {
      alerts.success('Archiving report...');
    } else {
      vm.doArchive = false;
    }

    return reportsDataService.viewAppReportByReportGroup(
      reportGroupId,
      renderFormat,
      parameters,
      vm.doArchive
    ).then((generateAppReportResponse) => {
      if (vm.saveType === 'runReport') {
        reportsDataService.viewReportBlob(generateAppReportResponse);
      } else {
        reportsDataService.download(generateAppReportResponse);
      }
    });
    // return reportsDataService.generateAppReportByReportGroup(
    //   reportGroupId,
    //   renderFormat,
    //   parameters,
    //   vm.doArchive
    // ).then((generateAppReportResponse) => {
    //   reportsDataService.download(generateAppReportResponse);
    // });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.reports.generateReportsDialog);
  }
}

SRGenerateReportDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',

  'alerts',
  'ssDialogService',
  'loaderService',
  'reportsDataService',
];
